import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { Alert } from 'react-bootstrap';

import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import { Row } from "../../components/Row";
import { Spaces } from "../../components/Spaces";
import { TextDisplay } from "../../components/TextDisplay/TextDisplay";
import { Loader } from "../../components/Loader";
import Bold from '../../components/Bold.js';
import { default_func_jsx_fail, FaAlertIcon, FaInfoCircle } from '../../helpers/helpers.js';
import useLog from '../../hooks/useLog.js';
import { confirmPopup, confirmPopupHard } from '../../components/confirmPopup.js';
import useTxSender from '../../hooks/useTxSender.js';
import SuccessTxSender from '../../components/SuccessTxSender.js';
import InputTokenAddress from '../../components/InputTokenAddress.js';
import RowWithTitle from '../../components/RowWithTitle.js';
import TxStateContext from '../../Contexts/TxStateContext.js';
import Constants from '../../config.js';

import CreateContractOptions from '../../components/CreateContractOptions/CreateContractOptions.tsx';

export default function Slide_TokkenR_Create(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_TokkenR_Create: ")

	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_createContract" // or mint_delphe ?
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à minter va s'afficher ici"

	// state & refs
	const ref_messageEndRef = useRef(null) // for autoscroll
	const [new_tokenName, set_new_tokenName] = useState("")
	// const [nbtokens, set_nbtokens] = useState(null)

	/**
	 * nbdecimales could be a useState with a field,
	 * but for now let's use 2 anyway, since everything has been coded for 2 decimals
	 **/
	const nbdecimales = 2

	const array_bool_user_inputs = [
		Boolean(new_tokenName && new_tokenName.length > 0),
	]

	// const token_balance = context.tokens_balance[tokenID]
	const bool_context_has_loaded = true //(token_balance !=null) // && (context.bsvprice !=null)

	// --- FUNCTIONS ---

	// // do only once
	// useEffect(()=>{
	// 	const fetchData = async () => {
	// 		log("fetchData : start")
	// 		const revoker_origin = (await context.get_revokerjig()).origin
	// 		log("fetchData : revoker_origin=",revoker_origin)
	// 		set_revoker_origin(revoker_origin)
	// 	}
	// 	log("calling fetchData()")
	// 	fetchData()
	// }, [])

	async function func_empty_fields() {
		set_new_tokenName("")
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null // add one by one
	if (new_tokenName && new_tokenName.length > 0) {
		jsx_recap = <Fragment>
			{jsx_recap}Création d'un nouveau contrat TokkenR:
			<br />- Nom du token: {new_tokenName}
			<br />- Nombre de decimales: {nbdecimales}
			{/* <br/>Nombre de tokens à créer initialement: {this.state.nbtokens} */}
		</Fragment>
	}

	const txStateContext = useContext(TxStateContext)
	const txstate = txStateContext.sendtxs_state ? txStateContext.sendtxs_state[tokenActionID] : null

	const func_jsx_sending = (txstate) => {
		return (<Fragment>
			Création du contrat TokkenR pour le token "{new_tokenName}" en cours... &nbsp;
			<i className="reloadIcon fas fa-sync fa-spin" />
			{txstate && txstate["status_detail_jsx"] ? txstate["status_detail_jsx"] : null}
		</Fragment>
		)
	}
	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Création avec succès du contrat TokkenR pour le token "{txstate.token_name}"<br />
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			func_jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)

	// --- FUNCTIONS ---

	function handleChange_new_tokenName(event) {
		var new_val = event.target.value

		func_resetMess()

		log("new token name to create=", new_val)
		set_new_tokenName(new_val)
	}

	// function handleChange_nbtokens(event){
	// 	var val = event.target.value
	// 	val = val.toString().replace(/[^0-9.,]/g, "");
	// 	val = parseInt(val)
	// 	this.setState({nbtokens: val})
	// }

	const handleClick = async (event) => {
		event.preventDefault() // prevent redirection

		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		const confirm_message = "⚠️ ETES VOUS CERTAIN DE VOULOIR CREER UN CONTRAT TOKKENR pour " + new_tokenName + " ? ⚠️"
		const confirmed = await confirmPopup(confirm_message)
		if (!confirmed) return // abort

		var message = "⚠️ Pensez à bien sauvegarder l'adresse du contract TokkenR qui va s'afficher ⚠️"
		if (!Constants.IS_WEB_BUILD) { // electron app
			await window.electron.openDialogShowMessageBox({ title: "Attention", message: message })
		} else { // web
			alert(message)
		}

		// async but we don't want to await here !
		userContext.create_contract(new_tokenName, nbdecimales)
	}

	// --- DISPLAY ---

	log("\n new_tokenName=", new_tokenName,
		"\n bool_broadcast_lock=", bool_broadcast_lock,
		"\n bool_context_has_loaded=", bool_context_has_loaded,)

	return (
		<div>
			<h1><i className="fas fa-file-signature" /><Spaces count="3" />
				Créer un nouveau contrat TokkenR
			</h1>
			<br />

			<Alert variant="light">
				<FaInfoCircle />
				Un contrat TokkenR inclut un contrat de mintuples créé avec un mintuple d'initialisation à 1.0,
				ainsi qu'un contrat de blacklist et un contrat de revoke.
			</Alert>
			<br />

			<RowWithTitle title={<Fragment>
				Nom du token
			</Fragment>}>
				<input type='text' value={new_tokenName} onChange={handleChange_new_tokenName}
					id='tokenname' placeholder="Nom du nouveau token" className='item' />
			</RowWithTitle>

			<CreateContractOptions />

			{/*}
			<Row>
				Nombre de tokens à créer initialement
			</Row><Row>
				<input type='number' value={nbtokens}
						onChange={handleChange_nbtokens}  id='nbtokens'
						placeholder="100" className='item' min="0" step="1"/>
			</Row>
			*/}

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<pre id='create_token_show_origin' className='item red'>
					{txstate && txstate.contractOrigin ?
						<Fragment>
							⚠️ SAUVEGARDEZ L'ADRESSE DU CONTRACT TOKKENR SUIVANTE: ⚠️ <br />
							<br /> {txstate.contractOrigin}
						</Fragment>
						:
						"L'adresse du contract TokkenR à sauvegarder va s'afficher ici"
					}
				</pre>
			</Row>

			<Row>
				<button onClick={handleClick} style={dict_sendbutton_style}
					className="submitbutton" id="create_token_submit">
					Créer nouveau contrat TokkenR
				</button>
			</Row>

		</div>
	)
}
